/* @flow */
import enqueueIn from "nx-components/utils/enqueueIn";

export default class PromiseRetrier<ResolveType> {
  _promiseFactory: () => Promise<ResolveType>;
  _maxAttempts: number;
  _delayBetweenAttempts: number;
  _attempt: number;
  _resolved: boolean;
  _canceled: boolean;

  constructor(
    promiseFactory: () => Promise<ResolveType>,
    maxAttempts: number,
    delayBetweenAttempts: number // milliseconds
  ) {
    this._promiseFactory = promiseFactory;
    this._maxAttempts = maxAttempts;
    this._delayBetweenAttempts = delayBetweenAttempts;
  }

  async run(): Promise<ResolveType | void> {
    this._attempt = 0;

    let result;
    while (this._shouldContinue()) {
      this._attempt += 1;

      try {
        result = await this._promiseFactory();
        this._resolved = true;
      } catch (error) {
        if (this._shouldContinue()) {
          await this._delay();
          continue;
        } else if (!this._canceled) {
          throw error;
        }
      }
    }

    return result;
  }

  cancel(): void {
    this._canceled = true;
  }

  _delay(): Promise<void> {
    return new Promise((resolve) => {
      enqueueIn(resolve, this._delayBetweenAttempts);
    });
  }

  _shouldContinue(): boolean {
    return (
      !this._resolved && !this._canceled && this._attempt < this._maxAttempts
    );
  }
}



// WEBPACK FOOTER //
// ./src/PromiseRetrier.js